<arm-dialog [title]="'Advanced Search'" (onCancel)="onCancel()" (onSubmit)="onSubmit()">
    <div class="search-container">
        <div class="search-column">
            <mat-form-field>
                <mat-label>Name</mat-label>
                <input [(ngModel)]="search.name" matInput>
            </mat-form-field>

          <ac-input-container label="CAC State"   >
            <ac-select
              [(acModel)]="search.operativeState"
              [items]="search.cacStateSearchOptions"
              [allowClear]="true"
              [multiple]="false"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>


            <mat-form-field>
                <mat-label>Policy Studio Tag</mat-label>
                <input [(ngModel)]="search.tag" matInput>
            </mat-form-field>

          <ac-input-container label="Prefix Group"   >
            <ac-select
              [(acModel)]="search.attrGroupsIds"
              [items]="search.prefixGroupsSearchOptions"
              [allowClear]="true"
              [multiple]="true"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>
        </div>

        <div class="search-column">

          <ac-input-container label="Administrative State"   >
            <ac-select
              [(acModel)]="search.adminState"
              [items]="search.adminStateSearchOptions"
              [allowClear]="true"
              [multiple]="false"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>



          <ac-input-container label="SIP Header Name"   >
            <ac-select
              [(acModel)]="search.sipHeaderName"
              [items]="search.sipHeaderNameSearchOptions"
              [allowClear]="true"
              [multiple]="false"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>

            <mat-form-field>
                <mat-label>SIP Header Value</mat-label>
                <input [(ngModel)]="search.sipHeaderValue" matInput>
            </mat-form-field>


          <ac-input-container label="CAC Profile"   >
            <ac-select
              [(acModel)]="search.cacProfileId"
              [items]="search.cacProfileSearchOptions"
              [allowClear]="true"
              [multiple]="false"
              [bindValue]="'value'"
              [bindLabel]="'text'">
            </ac-select>
          </ac-input-container>
        </div>
    </div>
</arm-dialog>
